<template>
  <div
    v-if="shift"
    v-tooltip="tooltipText"
    class="shift-item"
    :style="{backgroundColor:!isMultipleShift&&color}"
  >
    <span v-if="schedule.startDate" style="font-size: x-small">{{schedule.startDate| moment('YYYY-MM-DD')}}<br></span>
    <template v-if="isMultipleShift">
      <div class="candidate-shifts">
        <span
          v-for="cShift of resolvedCandidateShifts"
          :key="cShift.id"
          class="shift-inline"
          :style="{backgroundColor: getShiftColor(cShift)}"
        >
          {{ cShift.name }}<br>
          {{ cShift.clockIn }} - {{ cShift.clockOut }}
        </span>
      </div>
    </template>
    <template v-else>
      {{ shift.name }} <br>
      {{ shift.clockIn }} - {{ shift.clockOut }}
    </template>
    <span v-if="schedule.endDate" style="font-size: x-small"> <br> {{schedule.endDate| moment('YYYY-MM-DD')}} </span>
  </div>
</template>

<script>
  import randomColor from 'randomcolor'
  export default {
    name: 'ShiftItem',
    props: ['shift', 'schedule', 'shifts'],
    computed: {
      color () {
        return this.shift.isRestDay ? '#ff9536' : this.shift.name ? this.shift.color || randomColor({ seed: this.shift.name }) : '#3c4858'
      },
      isMultipleShift () {
        return this.schedule && this.schedule.scheduleType === 'multiple' && this.schedule.candidateShifts && this.schedule.candidateShifts.length > 1
      },
      resolvedCandidateShifts () {
        if (!this.isMultipleShift) return []
        return (this.schedule.candidateShifts || []).map(id =>
          (this.shifts || []).find(s => s.id === id)
        ).filter(Boolean)
      },
      tooltipText () {
        if (!this.shift) return ''
        const parts = []
        if (this.schedule.startDate) {
          parts.push('From: ' + this.schedule.startDate)
        }
        if (this.schedule.endDate) {
          parts.push('To: ' + this.schedule.endDate)
        }
        if (this.isMultipleShift) {
          const shiftDetails = this.resolvedCandidateShifts.map(s => s.name + ' (' + s.clockIn + '-' + s.clockOut + ')').join(', ')
          parts.push('Shifts: ' + shiftDetails)
        } else {
          if (this.shift.isRestDay) {
            parts.push('Rest Day')
          } else {
            parts.push(this.shift.name + ' (' + this.shift.clockIn + ' - ' + this.shift.clockOut + ')')
          }
        }
        return parts.join(' | ')
      },
    },
    methods: {
      getShiftColor (s) {
        return s.color || randomColor({ seed: s.id })
      },
    },
  }
</script>

<style scoped>
.shift-item {
  padding: 5px;
  border-radius: 5px;
}
.candidate-shifts {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}
.shift-inline {
  display: inline-block;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: x-small;

}
</style>
